var map = {
	"./dashboard.svg": 1133,
	"./example.svg": 1134,
	"./eye-open.svg": 1135,
	"./eye.svg": 1136,
	"./form.svg": 1137,
	"./link.svg": 1138,
	"./nested.svg": 1139,
	"./password.svg": 1140,
	"./table.svg": 1141,
	"./tree.svg": 1142,
	"./user.svg": 1143
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1247;


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 1247
// module chunks = 1